import { useState, useEffect, useRef } from 'react';

export function useCountUp(target: number, duration = 1200) {
  const [value, setValue] = useState(0);
  const prevTarget = useRef(0);

  useEffect(() => {
    if (target === 0) { setValue(0); return; }
    // Bewegungsreduktion (Bericht 2.4/8.10): Zielwert sofort setzen statt zu
    // animieren. Gleiches Muster wie useSmoothCounter.
    const reduceMotion = typeof window !== 'undefined'
      && window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
    if (reduceMotion) {
      prevTarget.current = target;
      setValue(target);
      return;
    }
    const from = prevTarget.current;
    prevTarget.current = target;
    const startTime = performance.now();
    let raf: number;
    const animate = (now: number) => {
      // rAF timestamps can precede startTime — clamp so easing never undershoots
      const progress = Math.min(Math.max(0, now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(from + (target - from) * eased));
      if (progress < 1) raf = requestAnimationFrame(animate);
    };
    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);

  return value;
}
